import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Button, Tooltip } from '@crazyegginc/hatch';

import { usePermissions } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import FunnelsPNG from '@crazyegginc/hatch/dist/images/illustration-funnels2.png';
import FunnelsWebP from '@crazyegginc/hatch/dist/images/illustration-funnels2.webp';

export function NoFunnelsWall() {
  const permissions = usePermissions();
  const canEditFunnel = permissions.can('edit', FEATURES.FUNNELS).allowed;

  return (
    <Paywall>
      <Paywall.Image webp={FunnelsWebP} fallback={FunnelsPNG} width="253px" />
      <Paywall.Title>Create your funnel!</Paywall.Title>

      <Paywall.Body>
        <p className="max-w-md">
          Find out where your users are dropping off or converting most throughout your site. This will help you
          pinpoint areas to improve and boost conversions.
        </p>
      </Paywall.Body>

      <Tooltip show={!canEditFunnel} tooltipContent="You don't have permission to create a Funnel.">
        <Button
          component={Link}
          to="/funnels/edit"
          disabled={!canEditFunnel}
          className={classNames('mb-5', { 'pointer-events-none': !canEditFunnel })}
        >
          Create a Funnel
        </Button>
      </Tooltip>
    </Paywall>
  );
}
